import { takeLatest } from 'redux-saga/effects';
import { createPanelApiSaga } from '@/features/auth/store/panel-api-saga';
import * as staffAccessApi from '../api/staff-access.api';
import { changeStaffPassword } from './staff-access.slice';

/** Jenerik `apiSaga`: try/catch, jeton yenileme ve hata normalizasyonu tek yerde. */
const apiSaga = createPanelApiSaga();

export function* staffAccessSaga() {
  yield takeLatest(
    changeStaffPassword.request.type,
    apiSaga(changeStaffPassword, staffAccessApi.changeStaffPassword),
  );
}
